import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import useTranslation from "hooks/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PACKAGE_UPGRADE_LINK } from "utils/constants";

const getContainer = ({ userData }) => userData.container.data;

function PackageExpireModal() {
  const container = useSelector(getContainer);

  const isPackageExpired = container?.package?.type === "expire";

  const [showExpireModal, setShowExpireModal] = useState(
    container?.package?.type === "expire"
  );
  const {
    // getAppLocale,
    getTranslation,
  } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  useEffect(() => {
    setShowExpireModal(isPackageExpired);
  }, [isPackageExpired]);

  return (
    <Modal
      setVisibility={setShowExpireModal}
      visible={showExpireModal}
      className="confirmation-modal"
    >
      <ModalBody>
        <div>
          <div className="conv__body__header_block_user_modal_title">
            {t("MODAL").PACKAGE_EXPIRE}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div
          style={{ width: "100%", justifyContent: "center" }}
          className="modal__container__footer__left"
        >
          <a
            rel="noreferrer"
            target="_blank"
            className="btn btn-primary"
            href={PACKAGE_UPGRADE_LINK}
            style={{ fontWeight: "bold" }}
          >
            {t("MODAL").BUY_AND_RENEWAL}
          </a>

          <button
            onClick={() => setShowExpireModal(false)}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("MODAL").CLOSE}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default PackageExpireModal;
